var _defs, _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotCrossedDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: none;\n            stroke: #fff;\n            stroke-linecap: round;\n            stroke-miterlimit: 10;\n            stroke-width: 1.5px;\n            }\n\n            .cls-2 {\n            fill: #1e1f2c;\n            }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10,
    cy: 10,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.59,
    y1: 6.59,
    x2: 13.41,
    y2: 13.41
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.41,
    y1: 6.59,
    x2: 6.59,
    y2: 13.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotCrossedDarkIcon);
export default __webpack_public_path__ + "static/media/dot-crossed-dark-icon.b3436fd335dace109d0ac02ab368199f.svg";
export { ForwardRef as ReactComponent };